import angular from 'angular';
import services from '../../services';
import utils from '../../utils';

const __module__ = 'leiApp.form',
  app = angular.module(__module__, [services, utils]),
  { controller, directive, component, service } = app;

export { app, controller, directive, component, service, __module__ as default };
